import React, {useEffect, useState} from 'react'
import {
    createPaymentMethod, getAccountSummary,
    getBusinessUsers, getCheckoutResult, getPaymentMethods,
    getSocialAccounts, getStripeIntent,
    getSubscription,
    inviteUser,
    enableEmailNotifications
} from "../services/BusinessService";
import plusIcon from "../icons/grey-plus-btn.png";
import moneyIcon from "../icons/DupeIcons-22-Payment.png";
import Modal from "react-modal";
import {loadStripe} from "@stripe/stripe-js";
import {
    Elements,
    PaymentElement,
    useElements,
    useStripe
} from "@stripe/react-stripe-js";
import pencilIcon from "../icons/blue-pencil.png";
import AccountCard from "./AccountCard";    
import Header from './Header';
import Button from './Button';
import IconButton from './IconButton';
import DepositModal from './DepositModal';
import instagramIcon from "../icons/DupeIcons-Instagram.png"
import { View, StyleSheet, Text, Image, TextInput, Pressable } from 'react-native-web';
import {useSearchParams} from "react-router-dom";
import { fetchAuthSession } from 'aws-amplify/auth';
const stripePromise = loadStripe((import.meta.env.VITE_REACT_APP_STRIPE_PK || process.env.REACT_APP_STRIPE_PK));

const Account = () => {
    const [facebookUrl] = useState("https://www.facebook.com/v17.0/dialog/oauth?response_type=token&display=popup&client_id=1330402327595027&redirect_uri=https%3A%2F%2Fbusiness.dupephotos.com%2Faccount%2Fcallback&auth_type=rerequest&scope=instagram_basic%2Cinstagram_content_publish");
    const [instagramAccounts, setInstagramAccounts] = useState({})
    const [subscription, setSubscription] = useState({})
    const [businessUsers, setBusinessUsers] = useState([])
    const [paymentMethods, setPaymentMethods] = useState([])
    const [options, setOptions] = useState({})
    const [addUserModal, setAddUserModal] = useState(false)
    const [updateCCModal, setUpdateCCModal] = useState(false)
    const [depositFundsModal, setDepositFundsModal] = useState(false)
    const [inviteError, setInviteError] = useState(false)
    const [newUser, setNewUser] = useState("")
    const [balance, setBalance] = useState(0)
    const [currentUserSub, setCurrentUserSub] = useState("")
    const [searchParams, setSearchParams] = useSearchParams();

    function openCCModal() {
        getStripeIntent()
            .then(resp => {
                if (resp.status === 200 && resp.data && resp.data.client_secret) {
                    setOptions({
                        clientSecret: resp.data.client_secret,
                        id: resp.data.id
                    });
                    setUpdateCCModal(true);
                }
            })
    }

    function openDepositModal() {
        setDepositFundsModal(true);
    }

    function refreshBalance() {
        getAccountSummary()
            .then(resp => {
                if (resp.status === 200 && resp.data && resp.data.balance) {
                    setBalance(resp.data.balance.amount);
                }
            })
            .catch(err => {
                console.error('Error refreshing balance:', err);
            });
    }

    function closeModal() {
        setAddUserModal(false);
        setUpdateCCModal(false);
        setInviteError(false);
        setDepositFundsModal(false);
    }

    const updateNewUser = (event) => {
        setNewUser(event.target.value);
    }

    function triggerUserInvite(event) {
        //event.preventDefault();
        if (newUser !== "") {
            let req = {};
            req.email = newUser;
            inviteUser(req)
                .then(resp => {
                    closeModal();
                })
                .catch(err => {
                    setInviteError(true);
                })
        }
    }

    function updateCard() {
        createPaymentMethod(options)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    closeModal();
                    window.location.reload();
                }
            })
    }


    useEffect(()=>{
        // Get current user's sub from Amplify
        fetchAuthSession()
            .then(session => {
                const sub = session?.tokens?.idToken?.payload?.sub;
                if (sub) {
                    setCurrentUserSub(sub);
                }
            })
            .catch(err => {
                console.error('Error fetching auth session:', err);
            });

        getSocialAccounts()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setInstagramAccounts(resp.data.instagramAccounts);
                }
            })
        getBusinessUsers()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setBusinessUsers(resp.data);
                }
            })
        getSubscription()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setSubscription(resp.data);
                }
            })
        getPaymentMethods()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    console.log(resp.data);
                    setPaymentMethods(resp.data);
                }
            })
        getAccountSummary()
            .then(resp => {
                if (resp.status === 200 && resp.data && resp.data.balance) {
                    setBalance(resp.data.balance.amount);
                }
            })
        if (searchParams.get("session_id")) {
            const req = {
                sessionId: searchParams.get("session_id"),
            }
            getCheckoutResult(req)
                .then(resp => {
                    if (resp.status === 200 && resp.data) {
                        getAccountSummary()
                            .then(resp => {
                                if (resp.status === 200 && resp.data && resp.data.balance) {
                                    setBalance(resp.data.balance.amount);
                                }
                            })
                    }
                })
        }

    }, []);
    return(
        <View>
            <Header title="Account" />
            <View style={styles.socialAccountsDiv}>
                <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginBottom: 15}}>
                    <View>
                        <Text style={[styles.sectionText, {marginBottom: 10}]}>Subscription</Text>
                        <View style={styles.sectionBackground}>
                            <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                <Text style={styles.blueText}>{subscription.name}</Text>
                                <Text style={styles.priceText}> ${subscription.price} / month</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.cardsDiv}>
                        <Text style={[styles.sectionText, {marginBottom: 10}]}>Card on File</Text>
                        <View>
                            {paymentMethods && paymentMethods.length > 0 && (
                                <View style={styles.sectionBackground}>
                                    <Text style={styles.paymentText}>&#8226;&#8226;&#8226;&#8226;</Text>
                                    <Text style={styles.paymentText}>{paymentMethods[0].card.last4}</Text>
                                    <Text style={styles.paymentText}>{paymentMethods[0].card.exp_month}/{paymentMethods[0].card.exp_year}</Text>
                                    <IconButton
                                        source={pencilIcon}
                                        onPress={() => {openCCModal()}}
                                        size={20}
                                        accessibilityLabel="Edit payment method"
                                    />
                                </View>
                            )}
                            {(!paymentMethods || paymentMethods.length < 1) && (
                                <View style={styles.sectionBackground}>
                                    <Text style={styles.paymentText}>&#8226;&#8226;&#8226;&#8226;</Text>
                                    <IconButton
                                        source={pencilIcon}
                                        onPress={() => {openCCModal()}}
                                        size={20}
                                        accessibilityLabel="Edit payment method"
                                    />
                                </View>
                            )}
                        </View>
                    </View>
                    <View style={styles.cardsDiv}>
                        <Text style={[styles.sectionText, {marginBottom: 10}]}>Your Funds</Text>
                        <View style={styles.sectionBackground}>
                            <IconButton
                                source={moneyIcon}
                                onPress={openDepositModal}
                                size={24}
                                accessibilityLabel="Deposit funds"
                            />
                            <Text style={styles.balanceText}>${balance}</Text>
                        </View>
                    </View>
                </View>
                <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginBottom: 15}}>
                    <View>
                        <Text style={[styles.sectionText, {marginBottom: 10}]}>Linked Instagram Accounts</Text>
                        {instagramAccounts && instagramAccounts.length > 0 && instagramAccounts.map(account  => (
                            <View key={account.id} style={[styles.sectionBackground, styles.instagramCard]}>
                                <Pressable 
                                    style={({ hovered }) => [
                                        styles.instagramAccountButton,
                                        hovered && styles.instagramAccountHovered
                                    ]} 
                                    onPress={()=> window.open(facebookUrl, "_blank")}
                                    accessible={true}
                                    accessibilityLabel={`View ${account.name} Instagram account`}
                                    accessibilityRole="button"
                                >
                                    <Image style={styles.facebookProfileImg} source={{uri: account.profileImageUrl}} alt="Instagram"/>
                                    <Text style={styles.instagramAccountText}> {account.name}</Text>
                                </Pressable>
                            </View>
                        ))}
                        {(!instagramAccounts || instagramAccounts.length < 1) && (
                            <View style={[styles.sectionBackground, styles.instagramCard]}>
                                <Pressable 
                                    style={({ hovered }) => [
                                        styles.instagramAccountButton,
                                        hovered && styles.instagramAccountHovered
                                    ]} 
                                    onPress={()=> window.open(facebookUrl, "_blank")}
                                    accessible={true}
                                    accessibilityLabel="Connect your Instagram account"
                                    accessibilityRole="button"
                                >
                                    <Image style={styles.instagramPlaceholderImg} source={instagramIcon} alt="Instagram"/>
                                    <Text style={styles.instagramConnectText}> Connect Your Instagram</Text>
                                </Pressable>
                            </View>
                        )}
                    </View>
                </View>
                <View>
                    <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10}}>
                        <Text style={styles.sectionText}>Account Users</Text>
                        <IconButton
                            source={plusIcon}
                            onPress={() => {setAddUserModal(true)}}
                            size={24}
                            accessibilityLabel="Add new user"
                        />
                    </View>
                    {businessUsers && businessUsers.length > 0 && businessUsers.map(account  => (
                        <AccountCard
                            key={account.id}
                            account={account}
                            currentUserSub={currentUserSub}
                            onEnableNotifications={enableEmailNotifications}
                        />
                    ))}
                </View>
                <Modal
                    isOpen={addUserModal}
                    onRequestClose={closeModal}
                    style={styles.modal}
                >
                    <View style={{alignItems: 'center', backgroundColor: 'white', borderRadius: 10, padding: 20}}>
                        <Text style={[styles.sectionText, {margin: 10}]}>Add User</Text>
                        {inviteError && (
                            <Text style={styles.errorText}>There was an error inviting that user. They may already have an invite</Text>
                        )}
                        <View style={{width: '70%'}}>
                            <TextInput style={styles.greyInput} value={newUser} onChange={updateNewUser} placeholder="User's Email" placeholderTextColor="#737373"/>
                            <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                                <Button text="Cancel" onPress={closeModal} variant='secondary' style={{marginRight: 10, marginTop: 10}} />
                                <Button text="Invite" onPress={triggerUserInvite} style={{marginTop: 10}}/>
                            </View>
                        </View>
                    </View>
                </Modal>
                <Modal
                    isOpen={updateCCModal}
                    onRequestClose={closeModal}
                    style={styles.modal}
                >
                    <View style={{alignItems: 'center', backgroundColor: 'white', borderRadius: 10, padding: 20}}>
                        <Text style={[styles.sectionText, {margin: 10}]}>Update Credit Card on File</Text>
                        {options.clientSecret && (
                            <Elements stripe={stripePromise} options={options}>
                                <StripeForm updateCard={updateCard} closeModal={closeModal} />
                            </Elements>
                        )}
                    </View>
                </Modal>
                <DepositModal
                    isOpen={depositFundsModal}
                    onClose={() => setDepositFundsModal(false)}
                    balance={balance}
                    onSuccess={refreshBalance}
                />
            </View>
        </View>

    );
}

const styles = StyleSheet.create({
    socialAccountsDiv: {
        margin: '4%',
    },
    sectionBackground: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        flexDirection: 'row',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        transition: 'all 0.2s ease',
        alignItems: 'center',
        minHeight: 74,
      },
      sectionText: {
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 30,
        fontWeight: 'bold',
        color: '#396de0',
      },
      blueText: {
        color: '#396de0',
        fontFamily: "'lato', sans-serif",
        fontSize: 18,
        fontWeight: 'bold',
      },
      priceText: {
        fontSize: 18,
        fontFamily: "'lato', sans-serif",
        color: '#000000',
      },
      paymentText: {
        fontWeight: 'bold',
        fontSize: 18,
        marginLeft: 20,
      },
      cardsDiv: {
        marginLeft: 15,
      },
      addCampaignImg: {
        width: 25,
        height: 25,
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
    },
    addCampaignImgHovered: {
        transform: [{ scale: 1.1 }],
    },
    addButtonContainer: {
        padding: 4,
        borderRadius: 6,
    },
    pencilIcon: {
        width: 20,
        height: 20,
    },
    pencilIconContainer: {
        padding: 4,
        borderRadius: 6,
        marginLeft: 20,
    },
    pencilIconHovered: {
        transform: [{ scale: 1.1 }],
    },
    fundsIcon: {
        width: 20,
        height: 20,
    },
    fundsIconContainer: {
        padding: 6,
        borderRadius: 6,
    },
    fundsIconHovered: {
        transform: [{ scale: 1.1 }],
    },
    balanceText: {
        marginLeft: 10,
        fontSize: 18,
        fontFamily: "'lato', sans-serif",
        fontWeight: '600',
        color: '#374151',
    },
    greyInput: {
        backgroundColor: '#f3f4f6',
        border: '1px solid #d1d5db',
        borderRadius: 8,
        width: '100%',
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 12,
        fontSize: 16,
        fontFamily: "'lato', sans-serif",
        transition: 'border-color 0.2s ease',
        outlineStyle: 'none',
    },
    modal:
    {
        overlay: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(57, 109, 224, .8)',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
        },
        content: {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            margin: 'auto',
            maxHeight: '80vh',
            background: 'none',
            border: 'none',
            borderRadius: 0,
            padding: 0,
            overflow: 'visible',
            width: 'auto',
            maxWidth: '90vw',
        }
    },
    errorText: {
        color: '#dc2626',
        marginBottom: 10,
        fontSize: 14,
        fontFamily: "'lato', sans-serif",
    },
    instagramCard: {
        paddingTop: 12,
        paddingBottom: 12,
        alignItems: 'center',
        marginBottom: 12,
    },
    instagramAccountButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        borderRadius: 8,
        transition: 'all 0.2s ease',
    },
    instagramAccountHovered: {
        backgroundColor: '#f3f4f6',
        transform: [{ scale: 1.02 }],
    },
    instagramAccountText: {
        fontSize: 18,
        fontFamily: "'lato', sans-serif",
        color: '#000000',
        fontWeight: '500',
    },
    instagramConnectText: {
        fontSize: 18,
        fontFamily: "'lato', sans-serif",
        color: '#396de0',
        fontWeight: '600',
    },
    facebookProfileImg: {
        width: 40,
        height: 40,
        borderRadius: 40,
    },
    instagramPlaceholderImg: {
        width: 40,
        height: 40,
    },
});

const StripeForm = ({updateCard, closeModal}) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        //event.preventDefault();
        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: "https://business.dupephotos.com/account",
            },
            redirect: "if_required",
        });

        if (error) {
            console.error(error);
            // handleError();
        } else {
            updateCard();
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                <Button text="Cancel" onPress={closeModal} variant='secondary' style={{marginTop: 10, marginRight: 10}}/>
                <Button text="Submit" onPress={handleSubmit} style={{marginTop: 10}}/>
            </View>
        </form>
    )
}

export default Account
